import BarCodeConstants from "@/utils/constants/BarCodeConstants.ts";
import {CriteriaExpressionSerializer, QuestionFieldsSerializer} from "@/utils/urlUtils/CriteriaAndQuestionsURLParser.ts";
import Base64 from "@/utils/urlUtils/Base64.ts";
import DTOFilledQuestionField = namaTypes.DTOFilledQuestionField;
import DTOExperssion = namaTypes.DTOExperssion;
import QuickFilterURLSerializer from "@/utils/urlUtils/QuickFilterURLSerializer.ts";
import ListViewQuickFilterButtonVal = namaTypes.ListViewQuickFilterButtonVal;

export default class ObjectToURLUtil {
  static fromURL(url: string | undefined, serializer: CriteriaExpressionSerializer | QuestionFieldsSerializer): any {
    if (!url)
      return undefined;
    url = Base64.decode(url);
    let objects:string[] = url.split(BarCodeConstants.contextsSeparator);
    let objectList:DTOFilledQuestionField[] | DTOExperssion[] = [];
    for (let i = 0; i < objects.length; i++) {
      let properties:string[] = objects[i].split(BarCodeConstants.entriesSepaarator);
      let propertiesMap:Map<string,any> = new Map();
      for (let j = 0; j < properties.length; j++) {
        let keyValue:string[] = properties[j].split(BarCodeConstants.keyValueSepaarator);
        if (keyValue.length != 2)
          continue;
        propertiesMap[keyValue[0]] = keyValue[1];
      }
      if (propertiesMap) {
        let object:object = serializer.fromProperties(propertiesMap);
        if (object) {
          objectList.push(object);
        }
      }
    }
    return objectList;
  }

  static listToString(list: string[]): string {
    let value: string[] = list || [];
    return value.join(BarCodeConstants.listSeperator);
  }

  static stringToList(str: string): string[] {
    if (!str)
      return [];
    return str.split(BarCodeConstants.listSeperator);
  }

  static toUrl(objects: (DTOFilledQuestionField | DTOExperssion| ListViewQuickFilterButtonVal)[] | undefined, serializer: CriteriaExpressionSerializer | QuestionFieldsSerializer| QuickFilterURLSerializer): string {
    let builder: string = "";
    objects = serializer.flattenIfNeeded(objects);
    if (objects) {
      for (let i = 0; i < objects.length; i++) {
        builder = this.addProperties(builder, serializer.toProperties(objects[i]));
        if (i < objects.length - 1) {
          builder += BarCodeConstants.contextsSeparator;
        }
      }
    }
    return Base64.encode(builder);
  }

  static addProperties(builder: string, properties: Map<string, any>): string {
    let j: number = 0;
    for (let [key, value] of properties) {
      if (value)
        value = value.id ?? value;
      builder += key + BarCodeConstants.keyValueSepaarator + (value ?? "");
      if (j < properties.size - 1) {
        builder += BarCodeConstants.entriesSepaarator;
      }
      j++;
    }
    return builder;
  }
}
